// extracted by mini-css-extract-plugin
module.exports = {"Header":"MarketplacePage_Header__2sTI0","Container":"MarketplacePage_Container__2mziB"};